import { DASHBOARD_URL, ENV, NEW_ADMIN_URL } from 'environment';
import { canFilter } from '../../mixins/can_filter';
import { canPaginate } from '../../mixins/can_paginate';
import { OriginThumbnail } from '../../utils/origin_thumbnail'
import './tickets_refund_form_controller';

angular
  .module('app.views')
  .config(($routeProvider) => {
    $routeProvider.when('/broadcasts/:id', {
      template: require('./broadcast.html'),
      controller: 'BroadcastController'
    });
  })
  .controller('BroadcastController', function($scope, $location, $timeout, $route, $routeParams, $modal, Broadcast, BroadcastUpload, Ticket, Account, $rootScope, $window, $http, $q){
    canFilter($scope, $location);
    canPaginate($scope, $location);
    $scope.newAdminURL = NEW_ADMIN_URL;
    $scope.selectedTickets = [];
    $scope.selectAll = false;
    $scope.validTicketCount = 0
    $scope.selectedTicketTotal = 0
    $scope.queryHasRun = false;
    $scope.queryRunning = false;
    $scope.defaultPageLength = 50;
    $scope.broadcast = Broadcast.get({id: $routeParams.id, include_recurrence: true, include_stream_diagnostics: true}, function(data){
      $scope.soldTicketCount = data.sold_ticket_count;
      $scope.totalTicketRevenue = data.sold_ticket_total;
      $scope.netTicketRevenue = data.net_ticket_total;
      $scope.refundedTotal = data.refunded_ticket_count;
      $scope.validTicketCount = $scope.soldTicketCount - $scope.refundedTotal;
      calculateShowBoxCastFlowControl();
      let params = _.pick($scope, 'q', 's', 'p');
      params.broadcast_id = $routeParams.id;
      params.l = $scope.defaultPageLength;
      $scope.tickets = Ticket.query(params, function(data, getResponseHeader) {
        $scope.unrefunded = _.where($scope.tickets, {is_refunded: false})
        const pagination = getResponseHeader('X-Pagination');
        $scope.pagination = (pagination ? JSON.parse(pagination) : {});
      });
      fixBroadcast();
      if ($scope.broadcast.stream_source === 'imported') {
        BroadcastUpload.query({broadcast_id: $routeParams.id}, (data) => {
          $scope.upload = _.find(data, u => u.recording_id === $scope.broadcast.recording_id);
        });
      } else {
        BroadcastUpload.query({broadcast_id: $routeParams.id}, (data) => {
          $scope.upload = data[0];
        });
      }
      Account.get({id: data.account_id}, account => {
        $scope.account = account;
        calculateShowBoxCastFlowControl();
      })
      if (data.origin_name) {
        OriginThumbnail($http, $q, data.origin_name).then((url) => $scope.origin_thumbnail = url);
      }
    });

    function calculateShowBoxCastFlowControl() {
      const account = $scope.account;
      if (account && account.hasFeatureFlag('boxcast_flow_control_disabled')) {
        $scope.showBoxCastFlowControl = false;
        return;
      }

      const broadcast = $scope.broadcast;
      if (!broadcast) {
        $scope.showBoxCastFlowControl = false;
        return;
      }

      switch (broadcast.stream_source) {
        case 'app': // fall-through
        case 'boxcaster-pro':
          $scope.showBoxCastFlowControl = true;
          break;

        case 'boxcaster':
          $scope.showBoxCastFlowControl = (broadcast.boxcaster_id && broadcast.boxcaster_id[0] == "o");
          break;

        default:
          $scope.showBoxCastFlowControl = false;
          break;
      }
    }

    function fixBroadcast() {
      $scope.activeDiagnosticsAlerts = _.filter($scope.broadcast.stream_diagnostics.alerts, (a) => a.is_active);

      $scope.requestedVideoResolution = $scope.broadcast.requested_video_resolution;
      $scope.actualVideoResolution = $scope.broadcast.actual_video_resolution;
      if ($scope.broadcast.transcoder_profile == '1080p:us') {
        $scope.requestedVideoResolution = 1080;
        $scope.actualVideoResolution = 1080;
      }

      // Limit graph to 24 hours in duration
      $scope.graphStart = $scope.broadcast.starts_at;
      $scope.graphStop = $scope.broadcast.stops_at;
      if (Date.parse($scope.graphStop) - Date.parse($scope.graphStart) > 1000*60*60*24) {
        console.warn('Limiting graph duration due to exceeding of 24 hour duration');
        $scope.graphStart = moment($scope.graphStop).add(-24, 'hour').format();
      } else {
        console.log('Using entire broadcast duration for graph');
      }
    };

    $scope.isUndeleting = false;
    $scope.undelete = () => {
      if (confirm('Are you sure you want to undelete this broadcast?')) {
        $scope.isUndeleting = true;
        Broadcast.undelete({id: $routeParams.id}).$promise.then(
          () => { return $route.reload(); },
          (e) => {
            $scope.isUndeleting = false;
            console.error(e);
            return alert("There was an error undeleting this broadcast. Check the console for more details.");
          }
        );
      }
    };

    $scope.reloadMetadata = function() {
      var tmp = Broadcast.get({id: $routeParams.id, include_stream_diagnostics: true}, function(data) {
        $scope.broadcast = tmp;
        fixBroadcast();
      });
    };

    $scope.settings = {
      preview: false
    };

    $scope.showTicket = e=> $location.path(`/broadcasts/${$routeParams.id}/tickets/${e.id}`);

    $scope.openScoreDataPage = function(){
      const isLive = ($scope.broadcast.stream_id && !$scope.broadcast.recording_id);
      const from = new Date(Date.parse($scope.broadcast.starts_at));
      const to = isLive ? new Date() : new Date(Date.parse($scope.broadcast.stops_at));
      const streamId = isLive ? $scope.broadcast.stream_id : $scope.broadcast.recording_id;
      $window.open(`https://app.datadoghq.com/logs?live=${isLive}&from_ts=${from.getTime()}&to_ts=${to.getTime()}&query=env:${ENV}+@stream_id:${streamId}+service:origin+@tag:origin.scoredecode+"received new score data"`, "_blank");
    };

    $scope.openScoreWarningsPage = function(){
      const isLive = ($scope.broadcast.stream_id && !$scope.broadcast.recording_id);
      const streamId = isLive ? $scope.broadcast.stream_id : $scope.broadcast.recording_id;
      const from = new Date(Date.parse($scope.broadcast.starts_at));
      const to = isLive ? new Date() : new Date(Date.parse($scope.broadcast.stops_at));
      $window.open(`https://app.datadoghq.com/logs?live=${isLive}&from_ts=${from.getTime()}&to_ts=${to.getTime()}&query=env:${ENV}+@stream_id:${streamId}+service:origin+@tag:origin.scoredecode+status:warn`, "_blank");
    };

    $scope.adminToken = function(broadcast){
      const url = broadcast.admin_viewer_url;
      if (!url) { return null; }
      const parts = url.split('/');
      if (parts.length <= 1) { return null; }
      return parts[parts.length - 1];
    };

    $scope.impersonate = () => {
      Account.impersonate({id: $scope.broadcast.account_id}, (token) => {
        const { token_type, access_token, scope } = token;
        const path = `/#/events/${$scope.broadcast.id}`;
        window.open(`${DASHBOARD_URL}#${jQuery.param({token_type, access_token, scope, path})}`);
        $rootScope.$broadcast('impersonate_initiated');
      });
    };

    $scope.showAdvancedSettingsAndGraphs = () => ($scope.broadcast.stream_source != 'imported') && ($scope.broadcast.stream_source != 'recording');

    $scope.broadcastsUrl = () => `/broadcasts?f=account:${encodeURIComponent(encodeURIComponent(JSON.stringify({ active: true, id: $scope.broadcast.account_id, name: $scope.broadcast.account_name })))}+only_today`;

    $scope.recurringSeriesUrl = () => {
      const accountFilter = "account:" + encodeURIComponent(JSON.stringify({active: true, id: $scope.broadcast.account_id, name: $scope.broadcast.account_name}));
      const recurrenceIdFilter = "recurrence:" + encodeURIComponent(JSON.stringify({active: true, id: $scope.broadcast.recurrence.id}));
      return `/broadcasts?f=${encodeURIComponent(accountFilter + " " + recurrenceIdFilter)}`;
    };

    $scope.selectSingleTicket = function(ticket) {
      if(!$scope.selectedTickets.includes(ticket)){
        $scope.selectedTickets.push(ticket);
      } else {
        $scope.selectedTickets = $scope.selectedTickets.filter(function(value) {
          return value.id != ticket.id
        })
      }
      $scope.selectedTicketTotal = $scope.selectedTickets.length;
    };

    $scope.selectAllPageTickets = () => {
      if(!$scope.selectAll) {
        $scope.deselectAllTickets();
      } else {
        $scope.selectedTickets = $scope.unrefunded;
      }
      $scope.selectedTicketTotal = $scope.selectedTickets.length;
    };

    $scope.selectAllTickets = () => {
      $scope.selectAll = true
      if(!$scope.queryHasRun) {
        $scope.queryRunning = true;
        let params = _.pick($scope, 'q', 's', 'p');
        params.broadcast_id = $routeParams.id;
        params.l = $scope.soldTicketCount;
        Ticket.query(params, function(data) {
          $scope.totalTickets = data;
          $scope.unrefundedAllTickets = _.where($scope.totalTickets, {is_refunded: false})
          $scope.queryHasRun = true;
          $scope.queryRunning = false;
          $scope.selectedTickets = $scope.unrefundedAllTickets;
          $scope.selectedTicketTotal = $scope.validTicketCount;
          $scope.allTicketsSelected = true;
          }
        );
      } else {
        $scope.selectedTickets = $scope.unrefundedAllTickets;
        $scope.selectedTicketTotal = $scope.validTicketCount;
        $scope.allTicketsSelected = true;
      };
    };

    $scope.deselectAllTickets = () => {
      $scope.selectAll = false;
      $scope.selectedTickets = [];
      $scope.allTicketsSelected = false;
    };

    $scope.refundTickets = () =>
      $modal.open({
        template: require('./tickets_refund_form.html'),
        controller: 'TicketsRefundFormController',
        size: 'lg',
        backdrop: 'static',
        resolve: {
          tickets: () => $scope.selectedTickets,
          broadcast: () => $scope.broadcast,
          account: () => $scope.account,
          channel: () => {},
        },
      }).result.then(() => {
        $route.reload();
      });
  });


// WEBPACK FOOTER //
// ./views/broadcast/broadcast_controller.js